import { render, staticRenderFns } from "./block-main.vue?vue&type=template&id=ce1f2f18&scoped=true&"
import script from "./block-main.vue?vue&type=script&lang=js&"
export * from "./block-main.vue?vue&type=script&lang=js&"
import style0 from "./block-main.vue?vue&type=style&index=0&id=ce1f2f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce1f2f18",
  null
  
)

component.options.__file = "block-main.vue"
export default component.exports